var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1528,
    height: 317,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_1933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016.44 416.102C1016.44 247.74 1152.99 111.254 1321.44 111.254C1489.88 111.254 1626.43 247.74 1626.43 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.31 416.102C1004.31 261.209 1140.87 135.498 1309.31 135.498C1477.75 135.498 1614.3 261.209 1614.3 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.187 416.102C992.187 274.678 1128.74 159.742 1297.18 159.742C1465.62 159.742 1602.17 274.678 1602.17 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.609 416.102C979.609 288.147 1116.16 184.435 1284.6 184.435C1453.05 184.435 1589.6 288.147 1589.6 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.482 416.102C967.482 301.615 1104.03 208.679 1272.48 208.679C1440.92 208.679 1577.47 301.615 1577.47 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.354 416.102C955.354 315.085 1091.91 232.924 1260.35 232.924C1428.79 232.924 1565.34 315.085 1565.34 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.227 416.102C943.227 328.554 1079.78 257.617 1248.22 257.617C1416.66 257.617 1553.66 328.554 1553.66 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.099 416.102C931.099 342.023 1067.65 281.861 1236.09 281.861C1404.53 281.861 1541.09 342.023 1541.09 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.521 416.102C918.521 355.492 1055.07 306.105 1223.51 306.105C1391.96 306.105 1528.51 355.492 1528.51 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.394 416.102C906.394 368.96 1042.94 330.798 1211.39 330.798C1379.83 330.798 1516.38 368.96 1516.38 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.266 416.102C894.266 382.429 1030.82 355.042 1199.26 355.042C1367.7 355.042 1504.25 382.429 1504.25 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.138 416.102C882.138 395.898 1018.69 379.287 1187.13 379.287C1355.57 379.287 1492.12 395.898 1492.12 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.44 416.102C1321.44 247.74 1184.89 111.254 1016.44 111.254C848 111.254 711 247.74 711 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.56 416.102C1333.56 261.209 1197.01 135.498 1028.57 135.498C860.128 135.498 723.577 261.209 723.577 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.14 416.102C1346.14 274.678 1209.59 159.742 1041.15 159.742C872.705 159.742 735.705 274.678 735.705 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.27 416.102C1358.27 288.147 1221.72 184.435 1053.28 184.435C884.833 184.435 747.833 288.147 747.833 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.4 416.102C1370.4 301.615 1233.85 208.679 1065.4 208.679C896.961 208.679 759.961 301.615 759.961 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.52 416.102C1382.52 315.085 1245.97 232.924 1077.53 232.924C909.089 232.924 772.089 315.085 772.089 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.65 416.102C1394.65 328.554 1258.1 257.617 1089.66 257.617C921.217 257.617 784.666 328.554 784.666 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.23 416.102C1407.23 342.023 1270.68 281.861 1102.24 281.861C933.793 281.861 796.793 342.023 796.793 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.36 416.102C1419.36 355.492 1282.81 306.105 1114.36 306.105C945.921 306.105 809.37 355.492 809.37 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.48 416.102C1431.48 368.96 1294.93 330.798 1126.49 330.798C958.049 330.798 821.498 368.96 821.498 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.61 416.102C1443.61 382.429 1307.06 355.042 1138.62 355.042C970.177 355.042 833.626 382.429 833.626 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1455.74 416.102C1455.74 395.898 1319.19 379.287 1150.75 379.287C982.305 379.287 845.754 395.898 845.754 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.87 416.102C1467.87 409.367 1331.32 403.98 1162.88 403.98C994.433 403.98 857.882 409.367 857.882 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.01 416.102C870.01 409.367 1006.56 403.98 1175 403.98C1291.34 403.98 1392.41 406.674 1444.06 410.265",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931.87 416.102C1931.87 247.74 1795.32 111.254 1626.88 111.254C1458.44 111.254 1321.89 247.74 1321.89 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944 416.102C1944 261.209 1807.45 135.498 1639.01 135.498C1470.56 135.498 1333.56 261.209 1333.56 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.58 416.102C1956.58 274.678 1820.03 159.742 1651.58 159.742C1483.14 159.742 1346.59 274.678 1346.59 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.71 416.102C1968.71 288.147 1832.15 184.435 1663.71 184.435C1495.27 184.435 1358.72 288.147 1358.72 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980.83 416.102C1980.83 301.615 1844.28 208.679 1675.84 208.679C1507.4 208.679 1370.85 301.615 1370.85 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1992.96 416.102C1992.96 315.085 1856.41 232.924 1687.97 232.924C1519.53 232.924 1382.97 315.085 1382.97 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.09 416.102C2005.09 328.554 1868.54 257.617 1700.1 257.617C1531.65 257.617 1395.1 328.554 1395.1 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2017.22 416.102C2017.22 342.023 1880.67 281.861 1712.22 281.861C1543.78 281.861 1407.23 342.023 1407.23 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2029.79 416.102C2029.79 355.492 1893.24 306.105 1724.8 306.105C1556.36 306.105 1419.81 355.492 1419.81 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2041.92 416.102C2041.92 368.96 1905.37 330.798 1736.93 330.798C1568.49 330.798 1431.93 368.96 1431.93 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2054.05 416.102C2054.05 382.429 1917.5 355.042 1749.06 355.042C1580.61 355.042 1444.06 382.429 1444.06 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066.18 416.102C2066.18 395.898 1929.63 379.287 1761.18 379.287C1592.74 379.287 1456.19 395.898 1456.19 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2078.31 416.102C2078.31 409.367 1941.75 403.98 1773.31 403.98C1604.87 403.98 1468.32 409.367 1468.32 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.45 416.102C1480.45 409.367 1617 403.98 1785.44 403.98C1901.78 403.98 2002.84 406.674 2054.5 410.265",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.863 416.102C710.863 247.74 574.312 111.254 405.87 111.254C237.427 111.254 100.876 247.74 100.876 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.991 416.102C722.991 261.209 586.44 135.498 417.998 135.498C249.555 135.498 113.004 261.209 113.004 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.119 416.102C735.119 274.678 598.568 159.742 430.126 159.742C261.683 159.742 125.132 274.678 125.132 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.696 416.102C747.696 288.147 611.145 184.435 442.703 184.435C274.26 184.435 137.709 288.147 137.709 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.823 416.102C759.823 301.615 623.272 208.679 454.83 208.679C286.387 208.679 149.836 301.615 149.836 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.951 416.102C771.951 315.085 635.4 232.924 466.958 232.924C298.515 232.924 161.964 315.085 161.964 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.079 416.102C784.079 328.554 647.528 257.617 479.086 257.617C310.643 257.617 173.643 328.554 173.643 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.207 416.102C796.207 342.023 659.656 281.861 491.214 281.861C322.771 281.861 186.22 342.023 186.22 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.784 416.102C808.784 355.492 672.233 306.105 503.791 306.105C335.348 306.105 198.797 355.492 198.797 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.912 416.102C820.912 368.96 684.361 330.798 515.919 330.798C347.476 330.798 210.925 368.96 210.925 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.04 416.102C833.04 382.429 696.489 355.042 528.047 355.042C359.604 355.042 223.053 382.429 223.053 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.168 416.102C845.168 395.898 708.617 379.287 540.174 379.287C371.732 379.287 235.181 395.898 235.181 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.87 416.102C405.87 247.74 542.42 111.254 710.863 111.254C879.306 111.254 1016.31 247.74 1016.31 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.742 416.102C393.742 261.209 530.292 135.498 698.735 135.498C867.178 135.498 1003.73 261.209 1003.73 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.164 416.102C381.164 274.678 517.715 159.742 686.158 159.742C854.601 159.742 991.601 274.678 991.601 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.037 416.102C369.037 288.147 505.587 184.435 674.03 184.435C842.473 184.435 979.473 288.147 979.473 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.909 416.102C356.909 301.615 493.459 208.679 661.902 208.679C830.345 208.679 967.345 301.615 967.345 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.781 416.102C344.781 315.085 481.332 232.924 649.774 232.924C818.217 232.924 955.217 315.085 955.217 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.653 416.102C332.653 328.554 469.204 257.617 637.646 257.617C806.089 257.617 942.64 328.554 942.64 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.077 416.102C320.077 342.023 456.627 281.861 625.07 281.861C793.513 281.861 930.513 342.023 930.513 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.949 416.102C307.949 355.492 444.499 306.105 612.942 306.105C781.385 306.105 917.936 355.492 917.936 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.821 416.102C295.821 368.96 432.372 330.798 600.814 330.798C769.257 330.798 905.808 368.96 905.808 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.693 416.102C283.693 382.429 420.244 355.042 588.686 355.042C757.129 355.042 893.68 382.429 893.68 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.565 416.102C271.565 395.898 408.116 379.287 576.558 379.287C745.001 379.287 881.552 395.898 881.552 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.437 416.102C259.437 409.367 395.988 403.98 564.43 403.98C732.873 403.98 869.424 409.367 869.424 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.296 416.102C857.296 409.367 720.745 403.98 552.302 403.98C435.965 403.98 334.899 406.674 283.243 410.265",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-204.567 416.102C-204.567 247.74 -68.0162 111.254 100.426 111.254C268.869 111.254 405.42 247.74 405.42 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.695 416.102C-216.695 261.209 -80.1441 135.498 88.2986 135.498C256.741 135.498 393.741 261.209 393.741 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-229.272 416.102C-229.272 274.678 -92.7213 159.742 75.7214 159.742C244.164 159.742 380.715 274.678 380.715 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-241.4 416.102C-241.4 288.147 -104.849 184.435 63.5935 184.435C232.036 184.435 368.587 288.147 368.587 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-253.528 416.102C-253.528 301.615 -116.977 208.679 51.4655 208.679C219.908 208.679 356.459 301.615 356.459 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-265.656 416.102C-265.656 315.085 -129.105 232.924 39.3376 232.924C207.78 232.924 344.331 315.085 344.331 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277.784 416.102C-277.784 328.554 -141.233 257.617 27.2096 257.617C195.652 257.617 332.203 328.554 332.203 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-289.911 416.102C-289.911 342.023 -153.36 281.861 15.0827 281.861C183.525 281.861 320.076 342.023 320.076 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-302.488 416.102C-302.488 355.492 -165.937 306.105 2.50551 306.105C170.948 306.105 307.499 355.492 307.499 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.616 416.102C-314.616 368.96 -178.065 330.798 -9.62238 330.798C158.82 330.798 295.371 368.96 295.371 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-326.744 416.102C-326.744 382.429 -190.193 355.042 -21.7502 355.042C146.692 355.042 283.243 382.429 283.243 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-338.872 416.102C-338.872 395.898 -202.321 379.287 -33.8782 379.287C134.564 379.287 271.115 395.898 271.115 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-351 416.102C-351 409.367 -214.449 403.98 -46.0061 403.98C122.437 403.98 258.987 409.367 258.987 416.102",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.859 416.102C246.859 409.367 110.309 403.98 -58.1341 403.98C-174.472 403.98 -275.537 406.674 -327.193 410.265",
    stroke: "#B4E5FC",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_1933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 417,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBackground);
export default __webpack_public_path__ + "static/media/hero-background.4d0d00bcb1734faaaaa5e1181a5f413f.svg";
export { ForwardRef as ReactComponent };